import { useCallback, useEffect, useRef, useState } from 'react'

/**
 * Порционный показ длинного списка: сначала `step` элементов, при прокрутке к низу —
 * ещё `step`. Данные при этом уже все на руках (фильтры и счётчики считают по всем),
 * порциями только рисуется. `resetKey` (фильтр, поиск) возвращает к первой порции.
 */
export const useRevealOnScroll = (total: number, resetKey: string, step = 24) => {
  const [shown, setShown] = useState(step)
  const [key, setKey] = useState(resetKey)
  if (key !== resetKey) {
    setKey(resetKey)
    setShown(step)
  }
  const observer = useRef<IntersectionObserver | null>(null)

  const sentinelRef = useCallback(
    (node: HTMLElement | null) => {
      observer.current?.disconnect()
      if (!node || typeof IntersectionObserver === 'undefined') return
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) setShown((n) => n + step)
        },
        { rootMargin: '400px' },
      )
      observer.current.observe(node)
    },
    [step],
  )
  useEffect(() => () => observer.current?.disconnect(), [])

  return { shown: Math.min(shown, total), hasMore: shown < total, sentinelRef }
}
